import { render, staticRenderFns } from "./Advogado.vue?vue&type=template&id=7e0a242a&scoped=true"
import script from "./Advogado.vue?vue&type=script&lang=js"
export * from "./Advogado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0a242a",
  null
  
)

export default component.exports